import {
  PRIVACY_CONTACT,
  PRIVACY_CONTENTS,
  PRIVACY_INTRO,
  PRIVACY_LAST_UPDATED,
  PRIVACY_SECTIONS,
} from "@/data/privacyPolicy";

function PrivacyBlock({ block }) {
  if (block.type === "h3") {
    return <h3 className="mt-8 text-lg font-bold text-ink">{block.text}</h3>;
  }
  if (block.type === "ul") {
    return (
      <ul className="mt-4 list-disc space-y-2 pl-5 text-base leading-relaxed text-ink/90">
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.type === "ol") {
    return (
      <ol className="mt-4 list-decimal space-y-2 pl-5 text-base leading-relaxed text-ink/90">
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ol>
    );
  }
  return <p className="mt-4 text-base leading-relaxed text-ink/90">{block.text}</p>;
}

export function PrivacyPolicyBody() {
  return (
    <div className="privacy-policy-body">
      {PRIVACY_INTRO.map((paragraph) => (
        <p key={paragraph.slice(0, 48)} className="mt-4 text-base leading-relaxed text-ink/90 first:mt-0">
          {paragraph}
        </p>
      ))}

      <nav aria-label="Privacy Policy contents" className="mt-10 rounded-2xl border-2 border-brand-100 bg-brand-50/60 p-5 sm:p-6">
        <h2 className="text-lg font-bold text-ink">Contents</h2>
        <ol className="mt-4 list-decimal space-y-2 pl-5 text-sm font-semibold text-ink/90 sm:text-base">
          {PRIVACY_CONTENTS.map((entry) => (
            <li key={entry.id}>
              <a href={`#${entry.id}`} className="text-brand-600 hover:underline decoration-brand-300 decoration-2 underline-offset-4">
                {entry.title}
              </a>
            </li>
          ))}
        </ol>
      </nav>

      {PRIVACY_SECTIONS.map((section) => (
        <section key={section.id} id={section.id} className="mt-12 scroll-mt-24 border-t border-brand-100 pt-10 first:mt-10">
          <h2 className="text-xl font-bold text-ink sm:text-2xl">{section.title}</h2>
          {section.blocks.map((block) => (
            <PrivacyBlock key={`${section.id}-${block.type}-${"text" in block ? block.text : block.items[0]}`} block={block} />
          ))}
          {section.id === "how-to-contact-us" ? (
            <dl className="mt-6 space-y-3 text-base leading-relaxed text-ink/90">
              <div>
                <dt className="font-bold text-ink">Company</dt>
                <dd>{PRIVACY_CONTACT.company}</dd>
              </div>
              <div>
                <dt className="font-bold text-ink">Website</dt>
                <dd>
                  <a
                    href={PRIVACY_CONTACT.website}
                    className="text-brand-600 hover:underline decoration-brand-300 decoration-2 underline-offset-4"
                  >
                    {PRIVACY_CONTACT.website}
                  </a>
                </dd>
              </div>
              <div>
                <dt className="font-bold text-ink">Email</dt>
                <dd>{PRIVACY_CONTACT.email}</dd>
              </div>
              <div>
                <dt className="font-bold text-ink">Telephone</dt>
                <dd>
                  <a href="tel:+918874200200" className="text-brand-600 hover:underline decoration-brand-300 decoration-2 underline-offset-4">
                    {PRIVACY_CONTACT.telephone}
                  </a>
                </dd>
              </div>
              <div>
                <dt className="font-bold text-ink">Office address</dt>
                <dd>{PRIVACY_CONTACT.address}</dd>
              </div>
            </dl>
          ) : null}
        </section>
      ))}
    </div>
  );
}
